import { render, staticRenderFns } from "./backup-settings-dialog.component.vue?vue&type=template&id=3cc19959&scoped=true"
import script from "./backup-settings-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./backup-settings-dialog.component.ts?vue&type=script&lang=ts&external"
import style0 from "./backup-settings-dialog.component.vue?vue&type=style&index=0&id=3cc19959&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc19959",
  null
  
)

export default component.exports